import { UserApi, UserApiResponse } from '../../../api';
import { useContainer } from '../../useContainer';

interface InstallTeamsBotPayload {
    activity: unknown;
}

const useInstallTeamsBot = () => {
    const userApi = useContainer(UserApi);

    const installBot = (body?: InstallTeamsBotPayload): Promise<UserApiResponse.TeamsIntegrationBotInstallResponse['body']> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.installTeamsIntegrationBot({
                body,
                onSuccess: res => {
                    const payload = (res.body as { body?: UserApiResponse.TeamsIntegrationBotInstallResponse['body'] })?.body;
                    resolve(payload ?? res.body);
                },
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { installBot };
};

export default useInstallTeamsBot;
